import { render, staticRenderFns } from "./databadan.vue?vue&type=template&id=22c18979"
import script from "./databadan.vue?vue&type=script&lang=js"
export * from "./databadan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports